export function startsWithFilter(fields: string[], values: string[]): string {
  if (fields.length != values.length || fields.length < 1) {
    throw 'fields and values do not have equal lengths';
  }

  const joined = fields.map((f, i) => `${f}(${values[i]})`).join(',');

  return `StartsWith(${joined})`;
}
